import { message, PageHeader, Select, Space, Spin, Table, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

// Orden unico de columnas: lo usan la tabla en pantalla y el Excel.
//   titulo: encabezado del Excel (en mayusculas, como el resto de los reportes)
//   tabla:  encabezado en pantalla
//   bloque: "alumno" | "venta" | "pago", solo para la banda de grupos del Excel
const COLUMNAS = [
  { key: "matricula",     titulo: "MATRICULA",              tabla: "Matrícula",              bloque: "alumno", ancho: 120, wch: 16 },
  { key: "alumno",        titulo: "ALUMNO",                 tabla: "Alumno",                 bloque: "alumno", ancho: 240, wch: 32 },
  { key: "escuela",       titulo: "ESCUELA",                tabla: "Escuela",                bloque: "alumno", ancho: 200, wch: 26 },
  { key: "grupo",         titulo: "GRUPO",                  tabla: "Grupo",                  bloque: "alumno", ancho: 140, wch: 18 },
  { key: "lista",         titulo: "LISTA / PAQUETE",        tabla: "Lista / Paquete",        bloque: "alumno", ancho: 200, wch: 26 },
  { key: "correo",        titulo: "CORREO",                 tabla: "Correo",                 bloque: "alumno", ancho: 220, wch: 30 },
  { key: "telefono",      titulo: "TELEFONO",               tabla: "Teléfono",               bloque: "alumno", ancho: 130, wch: 16 },
  { key: "celular",       titulo: "CELULAR",                tabla: "Celular",                bloque: "alumno", ancho: 130, wch: 16 },
  { key: "nivelPrepare",  titulo: "NIVEL PREPARE",          tabla: "Nivel Prepare",          bloque: "alumno", ancho: 130, wch: 16 },
  { key: "nivelIngles",   titulo: "NIVEL INGLES",           tabla: "Nivel Inglés",           bloque: "alumno", ancho: 120, wch: 14 },
  { key: "codigo",        titulo: "CODIGO",                 tabla: "Código",                 bloque: "alumno", ancho: 100, wch: 12 },
  { key: "rfc",           titulo: "RFC",                    tabla: "RFC",                    bloque: "alumno", ancho: 150, wch: 18 },
  { key: "estadoAlumno",  titulo: "ESTADO ALUMNO",          tabla: "Estado Alumno",          bloque: "alumno", ancho: 140, wch: 16 },
  { key: "alta",          titulo: "ALTA",                   tabla: "Alta",                   bloque: "alumno", ancho: 110, wch: 12 },

  { key: "folio",         titulo: "FOLIO",                  tabla: "Folio",                  bloque: "venta",  ancho: 130, wch: 16 },
  { key: "tipoDocumento", titulo: "TIPO",                   tabla: "Tipo",                   bloque: "venta",  ancho: 110, wch: 12 },
  { key: "fecha",         titulo: "FECHA",                  tabla: "Fecha",                  bloque: "venta",  ancho: 110, wch: 12 },
  { key: "origen",        titulo: "ORIGEN",                 tabla: "Origen",                 bloque: "venta",  ancho: 110, wch: 12 },
  { key: "paquete",       titulo: "PAQUETE DE LA VENTA",    tabla: "Paquete De La Venta",    bloque: "venta",  ancho: 220, wch: 30 },
  { key: "subtotal",      titulo: "SUBTOTAL DE LA VENTA",   tabla: "Subtotal De La Venta",   bloque: "venta",  ancho: 150, wch: 16, dinero: true },
  { key: "total",         titulo: "TOTAL DE LA VENTA",      tabla: "Total De La Venta",      bloque: "venta",  ancho: 150, wch: 16, dinero: true },
  { key: "importeAlumno", titulo: "IMPORTE DEL ALUMNO",     tabla: "Importe Del Alumno",     bloque: "venta",  ancho: 160, wch: 18, dinero: true },
  { key: "estadoVenta",   titulo: "ESTADO",                 tabla: "Estado",                 bloque: "venta",  ancho: 120, wch: 14 },

  { key: "pagadoPor",     titulo: "PAGADO POR",             tabla: "Pagado Por",             bloque: "pago",   ancho: 240, wch: 32 },
  { key: "correoPago",    titulo: "CORREO DE QUIEN PAGO",   tabla: "Correo De Quien Pagó",   bloque: "pago",   ancho: 220, wch: 30 },
  { key: "telefonoPago",  titulo: "TELEFONO DE QUIEN PAGO", tabla: "Teléfono De Quien Pagó", bloque: "pago",   ancho: 160, wch: 18 },
  { key: "facturadoA",    titulo: "FACTURADO A",            tabla: "Facturado A",            bloque: "pago",   ancho: 240, wch: 32 },
  { key: "rfcFacturadoA", titulo: "RFC FACTURADO A",        tabla: "RFC Facturado A",        bloque: "pago",   ancho: 150, wch: 18 },
];

const ETIQUETAS_BLOQUE = {
  alumno: "DATOS DEL ALUMNO",
  venta: "VENTA",
  pago: "PAGO",
};

const OPCIONES_COMPRA = [
  { valor: "todos", etiqueta: "Todos los alumnos" },
  { valor: "con", etiqueta: "Solo con compra" },
  { valor: "sin", etiqueta: "Solo sin compra" },
];

class ReporteAlumnosYVentas extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    filas: [],
    totales: null,
    empresa: null,
    periodo: null,
    escuelas: [],
    grupos: [],
    escuelasSeleccionadas: [],
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "reportesEscuela/catalogosReporteAlumnos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            escuelas: res.data.escuelas || [],
            grupos: res.data.grupos || [],
          });
        }
      })
      .catch(() => {});

    this.consultarReporte({
      periodo: [moment().startOf("month"), moment().endOf("month")],
      escuelas: [],
      grupos: [],
      conCompra: "todos",
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesEscuela/reporteAlumnosVentas",
        {
          empresaId: this.props.empresaId,
          fechaInicial: values.periodo[0].startOf("day").toISOString(),
          fechaFinal: values.periodo[1].endOf("day").toISOString(),
          escuelas: values.escuelas || [],
          grupos: values.grupos || [],
          conCompra: values.conCompra || "todos",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            filas: res.data.filas || [],
            totales: res.data.totales,
            empresa: res.data.empresa,
            periodo: res.data.periodo,
            loading: false,
          });
        } else {
          message.error(res.data.err || "Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false, filas: [], totales: null });
        }
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const { filas, totales, empresa, periodo } = this.state;
    const NUM_COLS = COLUMNAS.length;

    const HEADER_COLOR = "D9D9D9";
    const TITLE_COLOR = "BDD7EE";
    const TOTAL_COLOR = "F8CBAD";
    const ZEBRA_COLOR = "F5F7FA";
    const BLOQUE_COLOR = { alumno: "DDEBF7", venta: "E2EFDA", pago: "FCE4D6" };
    const GRIS = "8C8C8C";
    // Formato Contabilidad: el signo de pesos queda pegado al borde izquierdo
    // de la celda y el numero al borde derecho, en vez de ir junto al numero.
    const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';

    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const titleStyle = {
      font: { bold: true, sz: 13 },
      fill: { fgColor: { rgb: TITLE_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const bloqueStyle = (bloque) => ({
      font: { bold: true, sz: 11 },
      fill: { fgColor: { rgb: BLOQUE_COLOR[bloque] } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    });
    const headerStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const cellStyle = (zebra) => ({
      alignment: { vertical: "center" },
      ...(zebra ? { fill: { fgColor: { rgb: ZEBRA_COLOR } } } : {}),
      border,
    });
    const cellSinVentaStyle = (zebra) => ({
      font: { color: { rgb: GRIS }, italic: true },
      alignment: { vertical: "center" },
      ...(zebra ? { fill: { fgColor: { rgb: ZEBRA_COLOR } } } : {}),
      border,
    });
    const moneyStyle = (zebra) => ({
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      ...(zebra ? { fill: { fgColor: { rgb: ZEBRA_COLOR } } } : {}),
      border,
    });
    const totalLabelStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const totalMoneyStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };

    // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un objeto
    // { v, s } armado: sin "t" explicito escribe el numero como texto y Excel no
    // puede aplicarle el formato de moneda. La celda vacia conserva el estilo para
    // que si despues se escribe un numero encima ya salga en formato Contabilidad.
    const celdaMoneda = (valor, estilo) =>
      valor ? { v: valor, t: "n", s: estilo } : { v: "", s: estilo };

    const rows = [];
    const merges = [];

    // Fila 1: titulo
    const tituloTexto =
      `ALUMNOS Y VENTAS` +
      (empresa && empresa.nombre ? ` - ${empresa.nombre}` : "") +
      (periodo
        ? ` - DEL ${moment(periodo.fechaInicial).format("DD/MM/YYYY")} AL ${moment(
            periodo.fechaFinal
          ).format("DD/MM/YYYY")}`
        : "");
    rows.push(
      Array.from({ length: NUM_COLS }, (_, i) => ({
        v: i === 0 ? tituloTexto : "",
        s: titleStyle,
      }))
    );
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: NUM_COLS - 1 } });

    // Fila 2: banda de bloques (DATOS DEL ALUMNO / VENTA / PAGO)
    const filaBloques = [];
    COLUMNAS.forEach((col, i) => {
      const esInicioDeBloque = i === 0 || COLUMNAS[i - 1].bloque !== col.bloque;
      filaBloques.push({
        v: esInicioDeBloque ? ETIQUETAS_BLOQUE[col.bloque] : "",
        s: bloqueStyle(col.bloque),
      });
    });
    rows.push(filaBloques);
    let inicioBloque = 0;
    COLUMNAS.forEach((col, i) => {
      const esFinDeBloque = i === NUM_COLS - 1 || COLUMNAS[i + 1].bloque !== col.bloque;
      if (esFinDeBloque) {
        if (i > inicioBloque) {
          merges.push({ s: { r: 1, c: inicioBloque }, e: { r: 1, c: i } });
        }
        inicioBloque = i + 1;
      }
    });

    // Fila 3: encabezados
    rows.push(COLUMNAS.map((col) => ({ v: col.titulo, s: headerStyle })));

    // Datos
    filas.forEach((fila, indice) => {
      const zebra = indice % 2 === 1;
      rows.push(
        COLUMNAS.map((col) => {
          if (col.dinero) return celdaMoneda(fila[col.key], moneyStyle(zebra));
          const estilo =
            fila.sinVenta && col.bloque !== "alumno"
              ? cellSinVentaStyle(zebra)
              : cellStyle(zebra);
          if (fila.sinVenta && col.key === "folio") {
            return { v: "Sin compra en el periodo", s: estilo };
          }
          return { v: fila[col.key] || "", s: estilo };
        })
      );
    });

    // Totales
    if (totales) {
      const totalesRow = rows.length;
      const indiceSubtotal = COLUMNAS.findIndex((c) => c.key === "subtotal");
      rows.push(
        COLUMNAS.map((col, i) => {
          if (col.dinero) return { v: totales[col.key] || 0, t: "n", s: totalMoneyStyle };
          return {
            v:
              i === 0
                ? `TOTALES - ${totales.alumnos} alumno(s), ${totales.ventas} venta(s)`
                : "",
            s: totalLabelStyle,
          };
        })
      );
      merges.push({ s: { r: totalesRow, c: 0 }, e: { r: totalesRow, c: indiceSubtotal - 1 } });
    }

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!merges"] = merges;
    worksheet["!cols"] = COLUMNAS.map((col) => ({ wch: col.wch }));
    worksheet["!rows"] = [{ hpt: 22 }, { hpt: 18 }, { hpt: 30 }];
    // El autofiltro va de la fila de encabezados (3) a la ultima fila de datos, sin
    // incluir la de totales. Tiene que ser un rango de varias filas: si se le pasa uno
    // de una sola, xlsx-js-style lo expande a toda la hoja y se traga los totales.
    if (filas.length > 0) {
      const ultimaColumna = XLSXStyle.utils.encode_col(NUM_COLS - 1);
      worksheet["!autofilter"] = { ref: `A3:${ultimaColumna}${3 + filas.length}` };
    }
    // Nota: xlsx-js-style 1.2.0 no escribe <pane>, asi que no hay forma de dejar
    // encabezados congelados desde aqui (ni con !freeze ni con !panes).

    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Alumnos y Ventas");
    XLSXStyle.writeFile(
      workbook,
      `Alumnos_Y_Ventas_${moment().locale("es").format("DD-MM-YYYY")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  // Los grupos se acotan a las escuelas elegidas para no listar cientos de opciones.
  gruposVisibles() {
    const { grupos, escuelasSeleccionadas } = this.state;
    if (!escuelasSeleccionadas || escuelasSeleccionadas.length === 0) return grupos;
    const permitidas = new Set(escuelasSeleccionadas.map(String));
    return grupos.filter((g) => permitidas.has(String(g.escuelaId)));
  }

  onChangeEscuelas = (valores) => {
    const permitidas = new Set((valores || []).map(String));
    const gruposActuales = this.formRef.current?.getFieldValue("grupos") || [];
    // Si se acota la lista de escuelas, se limpian los grupos que ya no pertenecen.
    if (permitidas.size > 0 && gruposActuales.length > 0) {
      const gruposPorId = new Map(this.state.grupos.map((g) => [String(g._id), g]));
      const gruposValidos = gruposActuales.filter((id) =>
        permitidas.has(String(gruposPorId.get(String(id))?.escuelaId))
      );
      if (gruposValidos.length !== gruposActuales.length) {
        this.formRef.current?.setFieldsValue({ grupos: gruposValidos });
      }
    }
    this.setState({ escuelasSeleccionadas: valores || [] });
  };

  render() {
    const { filas, totales } = this.state;

    const columns = COLUMNAS.map((col) => {
      const base = {
        title: col.tabla,
        dataIndex: col.key,
        key: col.key,
        width: col.ancho,
        ellipsis: true,
      };
      if (col.dinero) {
        return {
          ...base,
          align: "right",
          render: (v) => (v || v === 0 ? dineroDisabledMask(v) : ""),
        };
      }
      if (col.key === "matricula" || col.key === "alumno") {
        return { ...base, fixed: "left" };
      }
      if (col.key === "folio") {
        return {
          ...base,
          render: (v, record) =>
            record.sinVenta ? (
              <span style={{ color: "#8c8c8c", fontStyle: "italic" }}>Sin compra</span>
            ) : (
              v
            ),
        };
      }
      return base;
    });

    const resumen = [
      { etiqueta: "Alumnos", valor: totales ? totales.alumnos : 0 },
      { etiqueta: "Ventas", valor: totales ? totales.ventas : 0 },
      { etiqueta: "Total", valor: dineroDisabledMask(totales ? totales.total : 0) },
      {
        etiqueta: "Importe del alumno",
        valor: dineroDisabledMask(totales ? totales.importeAlumno : 0),
      },
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteAlumnosYVentas"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().startOf("month"), moment().endOf("month")],
            conCompra: "todos",
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Alumnos y Ventas"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {filas.length > 0 && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                marginBottom: 10,
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Escuelas">
                  <FormItem name="escuelas" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Todas las escuelas"
                      onChange={this.onChangeEscuelas}
                    >
                      {this.state.escuelas.map((escuela) => (
                        <Option value={escuela._id} key={escuela._id}>
                          {escuela.nombre}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Grupos">
                  <FormItem name="grupos" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Todos los grupos">
                      {this.gruposVisibles().map((grupo) => (
                        <Option value={grupo._id} key={grupo._id}>
                          {grupo.nombre}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Compra">
                  <FormItem name="conCompra" noStyle margin>
                    <SelectItem width="90%" placeholder="Todos los alumnos">
                      {OPCIONES_COMPRA.map((opcion) => (
                        <Option value={opcion.valor} key={opcion.valor}>
                          {opcion.etiqueta}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 24,
                  marginBottom: 12,
                }}
              >
                {resumen.map((dato) => (
                  <div key={dato.etiqueta}>
                    <div style={{ fontSize: 12, color: "#8c8c8c" }}>{dato.etiqueta}</div>
                    <div style={{ fontSize: 18, fontWeight: 600 }}>{dato.valor}</div>
                  </div>
                ))}
              </div>

              {/* Table de antd directo y no TableItem: TableItem trae pagination y
                  scroll hardcodeados con tableLayout fijo, y con estas columnas
                  quedarian todas exprimidas sin scroll horizontal. */}
              <Table
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={filas}
                size="small"
                bordered
                scroll={{ x: "max-content", y: "60vh" }}
                pagination={{
                  defaultPageSize: 100,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} renglones`,
                }}
                rowClassName={(record, index) => (index % 2 === 0 ? "zebra-gris" : "default")}
              />
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteAlumnosYVentas);
